/**
 * Home, chapter 05 — "Choose your mission": services, as a mission board.
 * The list on paper, the selected mission on the night screen; its button
 * opens the contact page with the mission already written. The markup is
 * the server's (templates/site/sections/home/missions.html.twig); which
 * shops a mission shows is decided there (App\Site\Missions).
 *
 * @module sections/home/missions
 */

import { REDUCED_MOTION, TOUCH } from '../../config.js';
import { $$ } from '../../lib/dom.js';
import { gsap } from '../../lib/gsap.js';

/**
 * Hovering, focusing or tapping a mission puts it on the night screen.
 *
 * @param {HTMLElement} board
 */
export function animate(board) {
    const items = $$('[data-board-item]', board);
    const panels = $$('[data-board-panel]', board);
    let current = 0;

    /** @param {number} index */
    const select = (index) => {
        if (index === current || !panels[index]) {
            return;
        }

        current = index;
        items.forEach((item, position) => item.setAttribute('aria-pressed', String(position === index)));
        panels.forEach((item, position) => {
            item.hidden = position !== index;
        });

        if (!REDUCED_MOTION) {
            gsap.fromTo(
                panels[index].children,
                { opacity: 0, y: 14 },
                { opacity: 1, y: 0, duration: 0.45, stagger: 0.04, overwrite: true },
            );
        }
    };

    items.forEach((item, index) => {
        item.addEventListener('click', () => select(index));
        item.addEventListener('focus', () => select(index));

        if (!TOUCH) {
            item.addEventListener('mouseenter', () => select(index));
        }
    });
}
